import { getAxiosInstance } from "../../api";

export const downloadCertificate = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/kalyan-certificates/${id}/download`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const downloadKalyanExcel = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/kalyan-certificates/kalyan-download`, {
      params,
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const bulkDownloadCertificateUrls = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/kalyan-certificates/bulk/download-urls`,
      body,
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const bulkDownloadKalyanCertificateUrls = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/kalyan-certificates/download-urls`,
      body,
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const bulkUploadShopCertificate = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/kalyan-certificates/bulk/upload`,
      body,
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
